import React, { FC } from "react";
import "./ToggleButton.scss";
const ToggleButton: FC<{
  title: string;
  items: {
    title: string;
    icon: string;
    onClick: () => void;
    isActive: boolean;
    description: string;
    disabled?: boolean;
  }[];
}> = ({ title, items }) => {
  return (
    <div className="toggle-button">
      <p className="toggle-button__label">{title}</p>
      <div className="toggle-button__wrapper">
        {items.map((item, index) => {
          return (
            <button
              type="button"
              disabled={item.disabled}
              onClick={item.onClick}
              className={`toggle-button__item ${
                item.isActive &&
                `toggle-button__item--active ${
                  index === items.length - 1
                    ? "toggle-button__item--close"
                    : "toggle-button__item--open"
                }`
              }`}
            >
              <img
                src={item.icon}
                alt="Application status"
                className={`${
                  item.isActive
                    ? index === items.length - 1
                      ? "toggle-button__closed-lock-active"
                      : "toggle-button__opened-lock-active"
                    : index === items.length - 1
                    ? "toggle-button__closed-lock"
                    : "toggle-button__opened-lock"
                }`}
              />
              <div className="toggle-button__text">
                <p className="toggle-button__status-label">{item.title}</p>
                <p className="toggle-button__description">{item.description}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ToggleButton;
